import common from './common.json'
import volvoDriveaway from './schemes/volvo-driveaway.json'
import volvoSubscription from './schemes/volvo-subscription.json'

export default {
  common,
  'volvo-driveaway': volvoDriveaway,
  'volvo-subscription': volvoSubscription,
}
